import React, { useEffect, useState } from "react";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import ModalAddKiosk from "screens/ModalAddKiosk";
import Slider from "components/Slider";
import { useQuery, useMutation } from "@apollo/client";
import { GET_ALL_KIOSKS, ACTIVATE_KIOSK, DEACTIVATE_KIOSK } from "graphql/service";
import { Content, CouponTableContainer } from "./styles";
import { debouncedErrorMessage } from "utils/messageUtil";
import { RemoveIcon, EditIcon } from "assets/icons";

const Devices = () => {

  const [kiosks, setKiosks] = useState([]);

  const { data: kiosksData, error } = useQuery(GET_ALL_KIOSKS); 

  useEffect(() => {
    if (kiosksData) {
      setKiosks(kiosksData.kiosks);
    }
  }, [kiosksData]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

    const [activateKiosk] = useMutation(ACTIVATE_KIOSK,
    {
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const [deactivateKiosk] = useMutation(DEACTIVATE_KIOSK,
    { 
      onError: (error) => {
        if (!error.networkError) {
          let content = error.message
          if(error.message.includes('Validation')) {
              content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
          }
          debouncedErrorMessage(content);
        }
      }
    }
  );

  const handleActivate = (kioskId) => {
    activateKiosk({
      variables: { 
        kioskId: kioskId
      }
    }).then(()=>{
      setKiosks(prevKiosks => {
        return prevKiosks.map(kiosk => {
          if(kiosk.kioskId === kioskId) {
            return {
              ...kiosk,
              isDeleted: false
            }
          }
          return kiosk;
        });
      });
    });
  }

  const handleDeactivate = (kioskId) => {
    deactivateKiosk({
      variables: { 
        kioskId: kioskId
      }
    }).then(()=>{
      setKiosks(prevKiosks => {
        return prevKiosks.map(kiosk => {
          if(kiosk.kioskId === kioskId) {
            return {
              ...kiosk,
              isDeleted: true
            }
          }
          return kiosk;
        });
      });
    });
  }

  const kioskArray = kiosks.map((kiosk, index) => {
    return (
      <tr key={index}>
        <td className="deviceName">{kiosk.username}</td>
        <td className="paymentTerminal">{kiosk.devices?.find((device) => device.type === "PAYMENT_TERMINAL")?.name}</td>
        <td className="passportScanner">{kiosk.devices?.find((device) => device.type === "PASSPORT_SCANNER")?.name}</td>
        <td className="keycardDispenser">{kiosk.devices?.find((device) => device.type === "KEYCARD_DISPENSER")?.name}</td>
        <td className="onOff">
          <Slider
            checked={!kiosk.isDeleted}
            onActivate={() => handleActivate(kiosk.kioskId)}
            onDeactivate={() => handleDeactivate(kiosk.kioskId)}
          />
        </td>
        <td className="action">
          <span className="edit">
            <EditIcon /> Edit
          </span>
          <span className="delete">
            <RemoveIcon /> Remove
          </span>
        </td>
      </tr>
    );
  });

  return (
    <Card 
      additionalstyle={`
        height: auto;
        align-self: flex-start;
      `}
    >
      <CardHeader>
        <div className="type">CURRENT DEVICES</div>
        <div className="buttonContainer">
          <ModalAddKiosk
            buttonStyle={`
              width: 134px;
            `}
            setKiosks={setKiosks}
          />
        </div>
      </CardHeader>
      <Content>
        {kioskArray.length === 0 ? (
          <div className="noDevice">
            There are no kiosks available. Please use 'Add New Kiosk' to create one.
          </div>
        ) : (
          <>
            <div className="deviceDescription">
              “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. culpa qui officia
              deserunt mollierunt mollie.”
            </div>
            <CouponTableContainer>
              <thead>
                <tr>
                  <th className="deviceName">KIOSK NAME</th>
                  <th className="paymentTerminal">PAYMENT TERMINAL</th>
                  <th className="passportScanner">PASSPORT SCANNER</th>
                  <th className="keycardDispenser">KEYCARD DISPENSER</th>
                  <th className="onOff">ON/OFF</th>
                  <th className="action">ACTION</th>
                </tr>
              </thead>
              <tbody>{kioskArray}</tbody>
            </CouponTableContainer>
          </>
        )}
      </Content>
    </Card>
  );
};

export default Devices;
